export const PAYMENT_METHOD = {
  card: "Онлайн оплата карткою",
  postpaid: "Післяплата",
  requisites: "За реквізитами",
};

export const DELIVERY_METHOD = {
  novaPoshtaWarehouse: "Самовивіз з відділення Нової Пошти",
  novaPoshtaParcelLocker: "Самовивіз з поштомату Нової Пошти",
  novaPoshtaCourier: "Доставка кур’єром Нової Пошти",
};
